/**
 * Account / login page enhancements.
 *
 * Password Show/Hide toggle: each [data-sm-pass-toggle="#id"] button flips its
 * target input between password and text and swaps its own label. Labels are read
 * from data-label-show / data-label-hide (translated in PHP) so non-English
 * locales stay consistent. Progressive enhancement (the field is a normal
 * password input without JS). Safe to call on any page (no-op when there are no
 * toggles).
 */
export function initAccount() {
  document.querySelectorAll('[data-sm-pass-toggle]').forEach((btn) => {
    const target = document.querySelector(btn.getAttribute('data-sm-pass-toggle'));
    if (!target) {
      return;
    }
    const showLabel = btn.getAttribute('data-label-show') || btn.textContent;
    const hideLabel = btn.getAttribute('data-label-hide') || showLabel;
    btn.addEventListener('click', () => {
      const reveal = target.type === 'password';
      target.type = reveal ? 'text' : 'password';
      btn.textContent = reveal ? hideLabel : showLabel;
      btn.setAttribute('aria-pressed', reveal ? 'true' : 'false');
    });
  });
}
